import React from 'react'
import styled from 'styled-components'

export default function TwoOptionButton(
    { 
        componentLabel, 
        label1, 
        label2, 
        value1, 
        value2, 
        valueToCheckIfSelected, 
        callback1, 
        callback2,
        componentWidth = "35%",
        responseTypeLabelWidth = "100px",
        disabled = false,
    }) {
    return (
        <ResponseType>
            <ResponseTypeLabel width={responseTypeLabelWidth}>{componentLabel}</ResponseTypeLabel>
            <ResponseBtnWrap>
                <ResponseTypeBtn
                    disabled={disabled}
                    left
                    selected={valueToCheckIfSelected === value1}
                    onClick={callback1}
                    >{label1}</ResponseTypeBtn>
                <ResponseTypeBtn
                    right
                    disabled={disabled}
                    selected={valueToCheckIfSelected === value2}      
                    onClick={callback2}
                    >{label2}</ResponseTypeBtn>                                 
            </ResponseBtnWrap> 
        </ResponseType>
    )
}
const ResponseType = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => props.componentWidth};
    gap: 10px;
    justify-content: center;
    align-items: center; 
` 

const ResponseTypeLabel = styled.div`
    font-size: 12px;
    color: #858585;
    margin-top: 20px;
    width: ${props => props.width};
    font-weight: 500;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`
 
const ResponseBtnWrap = styled.div`
    display: flex;
    flex-direction: row;  
    align-items: center;
    z-index: 1; 
    position: relative;
`



const ResponseTypeBtn = styled.button`
    padding: 10px;
    border: none; 
    width: 80px;
    border-radius: ${props => props.left ? '11px 0px 0px 11px' : '0px 11px 11px 0px'};
    color: ${props => props.selected ? 'white' : '#ccc'};
    background-color: ${props => props.selected ? 'var(--themeColor)' : '#ebebeb'};
    cursor: pointer;
 
` 
 
 